import { useToast, TYPE } from "vue-toastification"

const toast = useToast()

const showToast = (message = "", type = TYPE.DEFAULT, timeout = 5000) => {

  if (message.length < 1) return

  if (!Object.values(TYPE).includes(type)) { // set defult type if type is not valid
    type = TYPE.DEFAULT
  }

  toast(message, {
    type: type,
    position: "top-right",
    timeout: timeout,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
  })

}

const showSuccessToast = (message, timeout = 5000) => {
  showToast(message, TYPE.SUCCESS, timeout)
}

const showErrorToast = (message, timeout = 5000) => {
  showToast(message, TYPE.ERROR, timeout)
}

const showInfoToast = (message, timeout = 5000) => {
  showToast(message, TYPE.INFO, timeout)
}

const showWarningToast = (message, timeout = 5000) => {
  showToast(message, TYPE.WARNING, timeout)
}

export { showToast, showSuccessToast, showErrorToast, showInfoToast, showWarningToast }
